module.exports = __webpack_public_path__ + "assets/img/1694.ad400328.png";